<template>
  <div>
    <hr v-if="!token.empresaModel.modulos.coNAOcadastra || token.role === 'CA'" >
    <div class="row" v-if="token.role === 'CO' || token.cadastra">
      <div class="col">
        <router-link v-if="!token.empresaModel.modulos.coNAOcadastra || token.role === 'CA'"  :to="`${route}/novo`" class="btn btn-block btn-primary btn-raised">
          + Adicionar um novo documento
        </router-link>
        <hr>
      </div>
    </div>

    <div class="row" v-if="token.role === 'CO'">
      <div class="col">
          <div class="alert alert-warning" role="alert" v-if="data.length === 0">
            Nenhum registro cadastrado.
          </div>

          <div id="accordion">
            <div class="card" v-for="item in data" :key="item._id">
              <div class="card-header" :id="'H' + item._id" data-toggle="collapse" :data-target="'#D' + item._id" >
                <div class="row">

                  <div class="col-1">
                    <i class="material-icons icone" :class="verificaValidade(item).classes">report_problem</i>
                  </div>

                  <div class="col-7">
                    {{item.licenca ? 'Licença': 'Protocolo'}} /
                    {{item.documento}} /
                    {{item.tipoLicenca}} /
                    {{item.atividade}}
                    <br>
                    <span v-if="!ehProtocolo(item)">
                      {{item.licenca ? verificaValidade(item).diff + ' dias para vencer' : ''}}
                      <br>
                      <small v-if="item.protocolado" :class="verificaValidade(item).classes">
                        protocolado {{verificaValidade(item).diffProtocolado}} dias antes do vencimento
                      </small>
                    </span>
                  </div>
                  <div class="col-4" v-if="!token.empresaModel.modulos.coNAOcadastra">
                     <a
                      href="javascript:;"
                      data-toggle="modal"
                      data-target="#protocolarModal"
                      @click="form.documento = item.documento;form._id = item._id"
                      v-if="!ehProtocolo(item)">
                      Protocolar
                      /
                    </a>
                    <router-link title="Alterar" :to="`${route}/edit/${item._id}`">
                      Atualizar Arquivo
                    </router-link>
                    /
                    <router-link title="Alterar" :to="`${route}/edit/${item._id}/over`">
                      Substituir
                    </router-link>
                  </div>
                </div>
              </div>

              <div :id="'D'+item._id" class="collapse" data-parent="#accordion">
                <div class="card-body">
                    <table class="table table-sm">
                      <tbody>
                        <tr>
                          <td>
                            <b>Licença: {{item.documento}} - {{item.tipoLicenca}}</b>
                          </td>
                          <td>
                            <b v-if="!ehProtocolo(item)">{{item.licenca ? 'Validade:' + formata(item.validade) : formata(item.data)}}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a class="btn btn-sm btn-raised btn-primary btn-block" v-if="item.filename" target="_blank"
                              :href="`${api}/api/v1${route}/doc/${item.filename}?token=${jwt}&mimetype=${item.mimetype}&original=${item.originalname}`"
                            >
                            Download Licença
                            </a>
                            <span v-if="!item.filename">Nenhum</span>
                          </td>
                          <td v-if="!token.empresaModel.modulos.coNAOcadastra">
                              <button
                                v-if="!ehProtocolo(item)"
                                type="button"
                                class="btn btn-sm btn-warning btn-block btn-raised"
                                data-toggle="modal"
                                data-target="#protocolarModal"
                                @click="form.documento = item.documento;form._id = item._id">
                                + Protocolar
                              </button>
                          </td>
                        </tr>
                        <tr v-if="item.protocolado">
                          <td>Protocolo: {{item.numeroProtocolo}} <br> Data: {{formata(item.data)}}</td>
                          <td>
                            <a class="btn btn-sm btn-block btn-secondary btn-raised" v-if="item.arquivoProtocolo && item.arquivoProtocolo.filename" target="_blank"
                              :href="`${api}/api/v1${route}/doc/${item.arquivoProtocolo.filename}?token=${jwt}&mimetype=${item.arquivoProtocolo.mimetype}&original=${item.arquivoProtocolo.originalname}`"
                            >
                            Download Protocolo
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                </div>
              </div>
            </div>
          </div>



      </div>
    </div>


    <div class="row mb-5" v-if="token.role === 'CA'">
      <div class="col">
        <ul class="nav nav-tabs justify-content-center">
          <li class="nav-item">
            <a class="nav-link"  :class="{'active': show === 2}" @click="updateShow(2)" href="#">Lista</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{'active': show === 1}" @click="updateShow(1)" href="#">Gráficos</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{'active': show === 3}" @click="updateShow(3)" href="#">Totais</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="row" v-if="token.role === 'CA'">
      <div class="col col-12" v-if="show !== 3">
        Total geral de documentos: <b>{{ totalPorTipo.reduce((sum, item) => sum + item.total, 0) }}</b>
      </div>

      <div class="col col-12" v-if="show !== 3">
        <div class="form-group">
          <label for="atividade">Atividade</label>
          <atividades v-on:input="setPage(1)" v-model="atividade" all="true" />
        </div>
      </div>

      <div class="col col-12" v-if="show !== 3">
        <div class="form-group">
          <label for="tipo">Tipo</label>
          <multiselect
            v-on:input="setPage(1)"
            v-model="tipos"
            :multiple="true"
            :close-on-select="false"
            :options="tiposLicenca"
            placeholder="Selecione um ou mais tipos"
            label="name"
            track-by="name"
            selectLabel="Pressione ENTER para selecionar"
            selectedLabel="Selecionado"
            deselectLabel="Pressione ENTER para remover"
            openDirection="top"
          >
          </multiselect>
        </div>
      </div>

      <div class="col col-12" v-if="show === 1">
        <pie class="mb-2" :chart-data="chartData1" :height="150"></pie>
        <button class="btn btn-sm btn-success btn-raised btn-block" type="button"  @click="export2image(0, 'Licencas')">Download</button>
        <hr>
      </div>

      <div class="col"  v-if="show === 2">
          <div class="alert alert-warning" role="alert" v-if="data.length === 0">
            Nenhum registro cadastrado.
          </div>

          <form v-on:submit.prevent="setPage(1)" v-if="token.role === 'CA' || token.role === 'ADM'">
            <fieldset>
            <legend>Filtrar</legend>
            <div class="form-group">
              <label for="filtro">Nome</label>
              <input v-model="filtro" id="filtro" type="text" class="form-control">
            </div>

            <div class="form-group">
              <label for="">Downloads:</label>
              <a class="btn btn-xs btn-danger btn-raised" target="_blank" :href="`${api}/api/v1${route}/download/vencidas?token=${jwt}`">Vencidas</a>
              <a class="btn btn-xs btn-success fundoverde btn-raised" target="_blank" :href="`${api}/api/v1${route}/download/validas?token=${jwt}`">Válidas</a>
              <a class="btn btn-xs btn-warning btn-raised" target="_blank" :href="`${api}/api/v1${route}/download/vencendo?token=${jwt}`">Vencendo</a>
              <a class="btn btn-xs btn-info btn-raised" target="_blank" :href="`${api}/api/v1${route}/download/protocoladas?token=${jwt}`">Protocoladas</a>
              <a class="btn btn-xs btn-default btn-raised" target="_blank" :href="`${api}/api/v1${route}/download/todas?token=${jwt}`">Todas</a>
            </div>
            </fieldset>
          </form>

          <ul class="list-group">
            <router-link
              tag='a'
              v-for="item in data" :key="item._id.usuario[0]._id"
            :to="`${route}/cooperado/${item._id.usuario[0]._id}`"
            class="border-bottom list-group-item list-group-item-action d-flex"
            :class="verificaValidade(item.licencas[0]).classes"
            >
              <i class="material-icons" :class="verificaValidade(item.licencas[0]).classes">report_problem</i>
              <i v-if="tdComAnexo(item)" class="material-icons">attach_file</i>
              {{item._id.usuario[0].nome}} <!-- .split(' ')[0] -->
            </router-link>
          </ul>
          <hr>

          <div class="row" v-if="data.length > 0 && (token.role === 'CO' || show === 2)" >
            <div class="col">
                <pagination :records="total" :options='pagOpts' :per-page="perPage" @paginate="setPage">
                </pagination>
            </div>
          </div>

          <hr>

          <legend>Sem Licença cadastrada:</legend>

          <div class="form-group">
            <label for="">Downloads:</label>
            <a class="btn btn-xs btn-info btn-raised" target="_blank" :href="`${api}/api/v1${route}/download/semlicenca/${atividade}/${filtro}?token=${jwt}`">Sem licença</a>
          </div>

          <div class="alert alert-warning" role="alert" v-if="sem.length === 0">
            Nenhum cooperado sem licença cadastrada.
          </div>

           <ul class="list-group">
            <router-link
              tag='a'
              v-for="item in sem" :key="item._id"
             :to="`${route}/cooperado/${item._id}`"
             class="border-bottom list-group-item list-group-item-action d-flex"
             >
               <i class="material-icons">report_problem</i>
              {{item.nome}}
            </router-link>
          </ul>

          <div class="row" v-if="sem.length > 0 && show === 2" >
            <div class="col">
                <pagination :records="totalSem" :options='pagOpts' :per-page="perPage" @paginate="getSem">
                </pagination>
            </div>
          </div>
      </div>

      <div class="col col-12" v-if="show === 3">
        <p class="float-right">
          Total: <b>{{ totalPorTipo.reduce((sum, item) => sum + item.total, 0) }}</b>
        </p>
        <table class="table table-sm table-striped">
          <thead>
            <th>Tipo</th>
            <th>Total</th>
          </thead>
          <tbody>
            <tr v-for="t in totalPorTipo">
              <td>{{traduzNome(t._id)}}</td>
              <td>{{t.total}}</td>
            </tr>
          </tbody>
        </table>
       
      </div>
    </div>


    <div class="modal fade" id="protocolarModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Protocolar Licença {{form.documento}}<br>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="numeroProtocolo" class="col-form-label">Número protocolo</label>
                <input type="text" v-model="form.numeroProtocolo" class="form-control" id="numeroProtocolo">
              </div>
              <div class="form-group" v-show="!form.licenca">
                <label for="data">Data</label>
                <input v-model="form.data" id="data" type="date" class="form-control">
              </div>
              <vue-dropzone ref="doc" id="doc" :options="dropzoneOptions" v-on:vdropzone-success="updateDoc"></vue-dropzone>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised mr-2" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary btn-raised" @click="adicionarProtocolo()">Protocolar</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import vueDropzone from 'vue2-dropzone';
import Pie from '../../../custom/Pie';

export default {
  components: {
    vueDropzone,
    Pie
  },
  data() {
    return {
      data: [],
      route: '/compromissos/ambientais',
      page: 1,
      perPage: 50,
      total: 0,

      pageSem: 1,
      sem: [],
      totalSem: 0,

      atividade: 'TODAS',
      tipos: [],
      filtro: '',
      pagOpts: this.$custom.pagOpts,
      form: {
        numeroProtocolo: '',
        data: moment().format('YYYY-MM-DD'),
        documento: '',
        _id: '',
        arquivoProtocolo: {
          mimetype: '',
          filename: '',
          originalname: ''
        }
      },
      chartData1: null,
      options: {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          callbacks: {
              label: function(tooltipItem, data) {
                var _data = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                return _data;
              }
          }
        },
        plugins: {
          labels: {
            render: 'value',
            precision: 0,
            showZero: false,
            fontSize: 18,
            fontColor: '#fefefe',
            fontStyle: 'bold',
            textShadow: true,
            shadowBlur: 5,
            shadowOffsetX: -1,
            shadowOffsetY: 1,
            shadowColor: "#000",
            arc: false,
            overlap: true,
            showActualPercentages: false,
            outsidePadding: 4,
            textMargin: 6,
            position: 'border',
          }
        }
      },
      show: 2,
      dropzoneOptions: this.$http.getDropzoneConfig(
        `/compromissos/ambientais/upload`,
        'post',
        {
          maxFiles: 1,
          addRemoveLinks: true,
          capture: true,
          dictDefaultMessage: 'Clique ou arraste arquivos aqui para UPLOAD',
          dictRemoveFile: 'Remover'
        }
      ),
      tiposLicenca: [
          { name: 'AA', value: 'AA' },
          { name: 'AA de Melhoria', value: 'AA de Melhoria' },
          { name: 'ADAPAR', value: 'ADAPAR' },
          { name: 'ALVARÁ', value: 'ALVARÁ' },
          { name: 'ALVARÁ LOCALIZAÇÃO', value: 'ALVARÁ LOCALIZAÇÃO' },
          { name: 'ALVARÁ SANITÁRIO', value: 'ALVARÁ SANITÁRIO' },
          { name: 'ANP CAOPA', value: 'ANP CAOPA' },
          { name: 'AUTORIZAÇÃO TRANSPORTE IBAMA', value: 'AUTORIZAÇÃO TRANSPORTE IBAMA' },
          { name: 'CERTIFICADO CORPO BOMBEIROS (CVCB)', value: 'CERTIFICADO CORPO BOMBEIROS (CVCB)' },
          { name: 'CERTIFICADO DE DESTINAÇÃO RESÍDUOS', value: 'CERTIFICADO DE DESTINAÇÃO RESÍDUOS' },
          { name: 'CREA', value: 'CREA' },
          { name: 'CRL', value: 'CRL' },
          { name: 'CTF IBAMA', value: 'CTF IBAMA' },
          { name: 'DAI', value: 'DAI' },
          { name: 'DAIL', value: 'DAIL' },
          { name: 'DECLARAÇÃO DE DISPENSA', value: 'DECLARACAODEDISPENSA' },
          { name: 'DECLARAÇÃO DE RENOVAÇÃO DO ALVARÁ SANITÁRIO', value: 'DECLARAÇÃO DE RENOVAÇÃO DO ALVARÁ SANITÁRIO' },
          { name: 'DLAE', value: 'DLAE' },
          { name: 'ISO', value: 'ISO' },
          { name: 'LAS', value: 'LAS' },
          { name: 'LASR', value: 'LASR' },
          { name: 'LI', value: 'LI' },
          { name: 'LI-A', value: 'LI-A' },
          { name: 'LO', value: 'LO' },
          { name: 'LO-A', value: 'LO-A' },
          { name: 'LOR', value: 'LOR' },
          { name: 'LP', value: 'LP' },
          { name: 'LP-A', value: 'LP-A' },
          { name: 'PLAN DE ACION', value: 'PLAN DE ACION' },
          { name: 'PROTOCOLO ALTERAÇÃO DE RAZÃO SOCIAL', value: 'PARS' },
          { name: 'POLICIA FEDERAL', value: 'POLICIA FEDERAL' },
          { name: 'PORTARIA DE OUTORGA', value: 'PORTARIADEOUTORGA' },
          { name: 'PROTOCOLO AA', value: 'PROTOCOLOAA' },
          { name: 'PROTOCOLO DE OUTORGA', value: 'PROTOCOLODEOUTORGA' },
          { name: 'PROTOCOLO DLAE', value: 'PROTOCOLODLAE' },
          { name: 'PROTOCOLO LI', value: 'PROTOCOLOLI' },
          { name: 'PROTOCOLO LAS', value: 'PROTOCOLOLAS' },
          { name: 'PROTOCOLO LO', value: 'PROTOCOLOLO' },
          { name: 'PROTOCOLO LOR', value: 'PROTOCOLOLOR' },
          { name: 'PROTOCOLO LO-A', value: 'PROTOCOLOLO-A' },
          { name: 'PROTOCOLO LP-A', value: 'PROTOCOLOLP-A' },
          { name: 'PROTOCOLO RLI', value: 'PROTOCOLORLI' },
          { name: 'PROTOCOLO RLO', value: 'PROTOCOLORLO' },
          { name: 'PROTOCOLO RLAS', value: 'PROTOCOLORLAS' },
          { name: 'REQUERIMENTO DE LI', value: 'REQUERIMENTO DE LI' },
          { name: 'REQUERIMENTO DE LO', value: 'REQUERIMENTO DE LO' },
          { name: 'REQUERIMENTO DE LP', value: 'REQUERIMENTO DE LP' },           
          { name: 'RLAS', value: 'RLAS' },
          { name: 'RLI', value: 'RLI' },
          { name: 'RLI-A', value: 'RLI-A' },
          { name: 'RLO', value: 'RLO' },
          { name: 'SERFLOR', value: 'SERFLOR' },
          { name: 'OUTORGA CAPTAÇÃO SUB', value: 'OUTORGA CAPTAÇÃO SUB' },
          { name: 'OUTORGA CAPTAÇÃO SUP', value: 'OUTORGA CAPTAÇÃO SUP' },
          { name: 'OUTORGA LANÇAMENTO', value: 'OUTORGA LANÇAMENTO' },
          { name: 'OUTRO', value: 'OUTRO' },
      ],
      totalPorTipo: []
    };
  },
  methods: {
    traduzNome(id) {
      var nomes = {
        "AA": "AA",
        "AA de Melhoria": "AA de Melhoria",
        "ADAPAR": "ADAPAR",
        "ADITIVO": "ADITIVO",
        "ALVARÁ": "ALVARÁ",
        "ANP CAOPA": "ANP CAOPA",
        "DECLARAÇÃO DE RENOVAÇÃO DO ALVARÁ SANITÁRIO": "DECLARAÇÃO DE RENOVAÇÃO DO ALVARÁ SANITÁRIO",
        "ISO": "ISO",
        "ALVARÁ SANITÁRIO": "ALVARÁ SANITÁRIO",
        "ALVARÁ LOCALIZAÇÃO": "ALVARÁ LOCALIZAÇÃO",
        "CERTIFICADO DE DESTINAÇÃO RESÍDUOS": "CERTIFICADO DE DESTINAÇÃO RESÍDUOS",
        "ANUÊNCIA PRÉVIA A DESMEMBRAMENTO - COM REMEMBRAMENTO": "ANUÊNCIA PRÉVIA A DESMEMBRAMENTO - COM REMEMBRAMENTO",
        "ANUÊNCIA PRÉVIA A DESMEMBRAMENTO": "ANUÊNCIA PRÉVIA A DESMEMBRAMENTO",
        "ANUÊNCIA PRÉVIA A LOTEAMENTO, CONDOMÍNIO OU CONJUNTO HABITACIONAL": "ANUÊNCIA PRÉVIA A LOTEAMENTO, CONDOMÍNIO OU CONJUNTO HABITACIONAL",
        "APROVAÇÃO DE LOTEAMENTO": "APROVAÇÃO DE LOTEAMENTO",
        "APROVAÇÃO DE PROJETO": "APROVAÇÃO DE PROJETO",
        "AR - ATESTADO DE REGULARIDADE": "AR - ATESTADO DE REGULARIDADE",
        "ATUALIZAÇÃO QUADRO ABNT": "ATUALIZAÇÃO QUADRO ABNT",
        "AUTORIZAÇÃO DE TERRAPLANAGEM": "AUTORIZAÇÃO DE TERRAPLANAGEM",
        "AVCB - AUTO DE VISTORIA DO CORPO DE BOMBEIROS": "AVCB - AUTO DE VISTORIA DO CORPO DE BOMBEIROS",
        "CADRI": "CADRI",
        "CARTA DE ANUÊNCIA": "CARTA DE ANUÊNCIA",
        "CARTA DE VIABILIDADE - ÁGUA": "CARTA DE VIABILIDADE - ÁGUA",
        "CARTA DE VIABILIDADE - ENERGIA": "CARTA DE VIABILIDADE - ENERGIA",
        "CARTA DE VIABILIDADE - ESGOTO": "CARTA DE VIABILIDADE - ESGOTO",
        "CERTIDÃO DE DIRETRIZES E PARÂMETROS URBANÍSTICOS": "CERTIDÃO DE DIRETRIZES E PARÂMETROS URBANÍSTICOS",
        "CERTIDÃO DE IMÓVEL URBANO E INEXISTÊNCIA DE RESERVA LEGAL E ÁREA DE APP": "CERTIDÃO DE IMÓVEL URBANO E INEXISTÊNCIA DE RESERVA LEGAL E ÁREA DE APP",
        "CERTIDÃO NEGATIVA DE DESAPROPRIAÇÃO": "CERTIDÃO NEGATIVA DE DESAPROPRIAÇÃO",
        "CERTIDÃO NEGATIVA DE TOMBAMENTO": "CERTIDÃO NEGATIVA DE TOMBAMENTO",
        "CERTIDÃO DE ART": "CERTIDÃO DE ART",
        "CERTIFICADO CORPO BOMBEIROS (CVCB)": "CERTIFICADO CORPO BOMBEIROS (CVCB)",
        "Certificação ISO": "Certificação ISO",
        "CN DE DESAPROPRIAÇÃO, TOMBAMENTO E PREEMPÇÃO": "CN DE DESAPROPRIAÇÃO, TOMBAMENTO E PREEMPÇÃO",
        "CONSULTA PRÉVIA": "CONSULTA PRÉVIA",
        "CONTRATO": "CONTRATO",
        "CREA": "CREA",
        "CRL": "CRL",
        "CTF IBAMA": "CTF IBAMA",
        "DAI": "DAI",
        "DAIL": "DAIL",
        "DECLARAÇÃO DE VIABILIDADE URBANA": "DECLARAÇÃO DE VIABILIDADE URBANA",
        "DECLARACAODEDISPENSA": "DECLARAÇÃO DE DISPENSA",
        "DIREITO DE PREEMPÇÃO": "DIREITO DE PREEMPÇÃO",
        "DISTRATO": "DISTRATO",
        "DLAE": "DLAE",
        "HABITE-SE": "HABITE-SE",
        "INTERFERÊNCIA DE PLANOS E PROJETOS": "INTERFERÊNCIA DE PLANOS E PROJETOS",
        "LAS": "LAS",
        "LASR": "LASR",
        "LC - LICENÇA DE CONSTRUÇÃO": "LC - LICENÇA DE CONSTRUÇÃO",
        "LI - LICENÇA DE INSTALAÇÃO": "LI - LICENÇA DE INSTALAÇÃO",
        "LI-A": "LI-A",
        "LI": "LI",
        "LO - LICENÇA DE OPERAÇÃ": "LO - LICENÇA DE OPERAÇÃO",
        "LO - LICENÇA DE OPERAÇÃO - CPRH": "LO - LICENÇA DE OPERAÇÃO - CPRH",
        "LO-A": "LO-A",
        "LO": "LO",
        "LOR": "LOR",
        "LP - LICENÇA PRÉVIA": "LP - LICENÇA PRÉVIA",
        "LP-A": "LPA",
        "LP": "LP",
        "LPU": "LPU",
        "OUTORGA - ÁGUA SUBTERRÂNEA": "OUTORGA - ÁGUA SUBTERRÂNEA",
        "OUTORGA - ÁGUA SUPERFICIAL": "OUTORGA - ÁGUA SUPERFICIAL",
        "OUTORGA CAPTAÇÃO SUB": "OUTORGA CAPTAÇÃO SUB",
        "OUTORGA CAPTAÇÃO SUP": "OUTORGA CAPTAÇÃO SUP",
        "OUTORGA LANÇAMENTO": "OUTORGA LANÇAMENTO",
        "OUTRO": "OUTRO",
        "PARECER TÉCNICO ": "PARECER TÉCNICO ",
        "PARECER TÉCNICO A PLANO URBANÍSTICO": "PARECER TÉCNICO A PLANO URBANÍSTICO",
        "PARS": "PROTOCOLO ALTERAÇÃO DE RAZÃO SOCIAL",
        "PLAN DE ACION": "PLAN DE ACION",
        "POLICIA FEDERAL": "POLICIA FEDERAL",
        "PORTARIADEOUTORGA": "PORTARIA DE OUTORGA",
        "PROJETO DE REFORMA COM OU SEM ACRÉSCIMO": "PROJETO DE REFORMA COM OU SEM ACRÉSCIMO",
        "PROJETOS ESPECIAIS": "PROJETOS ESPECIAIS",
        "PROTOCOLOAA": "PROTOCOLO AA",
        "PROTOCOLODEOUTORGA": "PROTOCOLO DE OUTORGA",
        "PROTOCOLODLAE": "PROTOCOLO DLAE",
        "PROTOCOLOLAS": "PROTOCOLO LAS",
        "PROTOCOLOLI": "PROTOCOLO LI",
        "PROTOCOLOLO-A": "PROTOCOLO LO-A",
        "PROTOCOLOLO": "PROTOCOLO LO",
        "PROTOCOLOLOR": "PROTOCOLO LOR",
        "PROTOCOLOLP-A": "PROTOCOLO LP-A",
        "PROTOCOLOLP": "PROTOCOLO LP",
        "PROTOCOLORLAS": "PROTOCOLO RLAS",
        "PROTOCOLORLI": "PROTOCOLO RLI",
        "PROTOCOLORLO": "PROTOCOLO RLO",
        "REGULARIZAÇÃO DE LOTEAMENTOS, CONDOMÍNIOS E CONJUNTOS HABITACIONAI": "REGULARIZAÇÃO DE LOTEAMENTOS, CONDOMÍNIOS E CONJUNTOS HABITACIONAIS",
        "REMEMBRAMENTO/DESMEMBRAMENTO/DEMARCAÇÃO URBANÍSTIC": "REMEMBRAMENTO/DESMEMBRAMENTO/DEMARCAÇÃO URBANÍSTICO",
        "REQUERIMENTO DE LI": "REQUERIMENTO DE LI",
        "REQUERIMENTO DE LO": "REQUERIMENTO DE LO",
        "REQUERIMENTO DE LP": "REQUERIMENTO DE LP",
        "RLAS": "RLAS",
        "RLI-A": "RLI-A",
        "RLI": "RLI",
        "RLO": "RLO",
        "SERFLOR": "SERFLOR",
        "TVO - TERMO DE VERIFICAÇÃO DE OBRA": "TVO - TERMO DE VERIFICAÇÃO DE OBRA"
      }

      return nomes[id]
    },
    ehProtocolo(item) {
      if (item.tipoLicenca.indexOf('PROTOCOLO') > -1 || item.tipoLicenca === 'PARS' ) {
        return true;
      }

      return false;
    },
    tdComAnexo(item) {
      let todosTem = true;
      for (let i = 0; i < item.licencas.length; i++) {
        const l = item.licencas[i];
        if (!l.filename && (!l.arquivoProtocolo || !l.arquivoProtocolo.filename)) {
          todosTem = false;
        }
      }

      return todosTem;
    },
    updateShow(num) {
      this.show = num;
      localStorage.setItem('a-show', num);
    },
    export2image: function(i, name) {
      let canvas = document
        .querySelectorAll('canvas')
        [i].toDataURL('image/png');
      let link = document.createElement('a');
      link.download = name;
      link.href = canvas;
      link.click();
    },
    getPiorCaso(itens) {
      let piorCasoDate = moment();
      let pior = itens[0];

      for (let i = 0; i < itens.length; i++) {
        const item = itens[i];
        const caso = moment(item.validade);

        if (!item.protocolado && caso < piorCasoDate) {
          piorCasoDate = caso;
          pior = item;
        }
      }

      return pior;
    },
    verificaValidade(item) {
      const hojeProtocolado = moment(item.data);
      const hoje = moment();
      const ate = moment(item.validade);

      let diff = ate.diff(hoje, 'days');
      let diffProtocolado = ate.diff(hojeProtocolado, 'days');

      if (diff < 0) diff = 0;
      if (diffProtocolado < 0) diffProtocolado = 0;

      let min = 120;
      let max = 150;

      if (
        item.tipoLicenca === 'SERFLOR' || 
        item.tipoLicenca === 'AA' || 
        item.tipoLicenca === 'CREA' || 
        item.tipoLicenca === 'ALVARÁ' || 
        item.tipoLicenca === 'ALVARÁ LOCALIZAÇÃO' || 
        item.tipoLicenca === 'AUTORIZAÇÃO TRANSPORTE IBAMA' || 
        item.tipoLicenca === 'ALVARÁ SANITÁRIO' || 
        item.tipoLicenca === 'OUTRO' || 
        item.tipoLicenca === 'POLICIA FEDERAL' || 
        item.tipoLicenca === 'CERTIFICADO CORPO BOMBEIROS (CVCB)'
        ) {
        min = 1;
        max = 30;
      }

      if (item.tipoLicenca === 'CTF IBAMA') {
        min = 1;
        max = 5;
      }

      if (item.tipoLicenca.indexOf("OUTORGA") > -1 || item.tipoLicenca === 'ADAPAR') {
        min = 90;
        max = 150;
      }

      return {
        classes: {
          amarelo: item.licenca && diff >= min && diff <= max,
          verde: item.licenca && diff > max,
          verdeProtocolo: item.protocolado && diffProtocolado >= min,
          vermelhoProtocolo: item.protocolado && diffProtocolado < min,
          vermelho: (
            item.licenca && diff < min && 
            (!item.protocolado || (item.protocolado && diffProtocolado < min))) ||
            item.protocolado && diffProtocolado < min,
        },
        diff,
        diffProtocolado
      };
    },
    formata(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    remove(id) {
      this.$http.delete(`${this.route}/${id}`).then(() => {
        this.setPage(this.page);
      });
    },
    setPage: function(page) {
      this.getSem(1);

      this.page = page;

      const skip = (page - 1) * this.perPage;
      const limit = this.perPage;
      const filtro = this.filtro;
      const tipos = this.tipos;

      localStorage.setItem('a-filtro', this.filtro);
      const atividade = this.atividade;

      let url = `${this.route}/list`;
      if (this.token.role === 'CA') {
        url += 'CA';
      }

      this.$http.post(url, { skip, limit, filtro, atividade, tipos }).then(r => {
        if (r.data.totalPorTipo) {
          this.totalPorTipo = r.data.totalPorTipo
        }

        this.data = r.data.data;
        this.total = r.data.total;

        if (this.token.role === 'CA') {
          const V = r.data.graficos.vermelho;
          const VP = r.data.graficos.vermelhoProtocolado;
          const A = r.data.graficos.amarelo;
          const D = r.data.graficos.verde;
          const P = r.data.graficos.protocolado;
          const S = r.data.graficos.totalSem;

          this.chartData1 = {
            labels: [
              `Vencidas`,
              `Protocoladas fora do pazo`,
              `Vencimento próximo`,
              `Válidas`,
              `Válidas com protocolo`,
              `Sem licença`
            ],
            datasets: [
              {
                backgroundColor: ['#F44336', '#EF9A9A', '#d98609', '#0a823b', '#52af78', '#495057'],
                data: [V, VP, A, D, P, S]
              }
            ]
          };
        }
      });
    },
    updateDoc(file, response) {
      this.form.arquivoProtocolo.mimetype = response.mimetype;
      this.form.arquivoProtocolo.filename = response.filename;
      this.form.arquivoProtocolo.originalname = response.originalname;
    },
    adicionarProtocolo() {
      this.$http.post(`${this.route}/protocolar`, this.form).then(response => {
        this.form = {
          numeroProtocolo: '',
          documento: '',
          data: moment().format('YYYY-MM-DD'),
          _id: '',
          arquivoProtocolo: {
            mimetype: '',
            filename: '',
            originalname: ''
          }
        };

        $('#protocolarModal').modal('hide');
        this.setPage(this.page);
      });
    },
    async getSem(pageSem) {
      this.pageSem = pageSem;

      const skip = (pageSem - 1) * this.perPage;
      const limit = this.perPage;
      const filtro = this.filtro;
      const atividade = this.atividade;

      let url = `${this.route}/listSem`;

      const r = await this.$http.post(url, {
        skip,
        limit,
        filtro,
        atividade
      });

      this.sem = r.data.sem;
      this.totalSem = r.data.totalSem;
    },
  },
  beforeMount() {
    const showFromStore = localStorage.getItem('a-show');

    if (showFromStore) {
      this.show = parseInt(showFromStore);
    }

    const filtroFromStorage = localStorage.getItem('a-filtro');

    if (filtroFromStorage) {
      this.filtro = filtroFromStorage;
    }

    this.setPage(1);
  }
};
</script>

<style scoped>
.id {
  font-size: 12px;
}

.card {
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/app/compromissos/ambientais/Home.vue